import { render, staticRenderFns } from "./hot_spot.vue?vue&type=template&id=86bd63ea&scoped=true"
import script from "./hot_spot.vue?vue&type=script&lang=js"
export * from "./hot_spot.vue?vue&type=script&lang=js"
import style0 from "./hot_spot.vue?vue&type=style&index=0&id=86bd63ea&prod&scoped=true&lang=less"
import style1 from "./hot_spot.vue?vue&type=style&index=1&id=86bd63ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bd63ea",
  null
  
)

export default component.exports